import { embedGQLFields, mediaGQLFields, } from '../media/index.js';
import { memberGQLFields, networkGQLFields, } from '../network/index.js';
const BASIC_APP_FIELDS = {};
const ALL_APP_FIELDS = {
    banner: 'basic',
    createdBy: 'basic',
    customCodes: 'basic',
    embeds: 'basic',
    favicon: 'basic',
    image: 'basic',
    images: 'basic',
    network: 'basic',
    updatedBy: 'basic',
};
export const appGQLFields = (fields) => {
    if (fields === 'basic')
        fields = BASIC_APP_FIELDS;
    if (fields === 'all')
        fields = ALL_APP_FIELDS;
    return `
    about
    authorName
    authorUrl
    clientId
    clientSecret
    comingSoon
    createdAt
    description
    docsUrl
    enabledContexts
    id
    imageId
    installed
    locked
    name
    networkId
    privacyPolicyUrl
    requiredPermissions
    requiredPlan
    secretToken
    slug
    standing
    status
    termsOfServiceUrl
    updatedAt
    webhookSignSecret
    webhookSubscriptions
    webhookUrl
    ${fields.banner
        ? `
      banner {
        ${mediaGQLFields(fields.banner)}
      }
    `
        : ``}
    ${fields.createdBy
        ? `
      createdBy {
        ${memberGQLFields(fields.createdBy)}
      }
    `
        : ``}
    ${fields.customCodes
        ? `
      customCodes {
        body
        head
      }
    `
        : ``}
    ${fields.embeds
        ? `
      embeds {
        ${embedGQLFields(fields.embeds)}
      }
    `
        : ``}
    ${fields.favicon
        ? `
      favicon {
        ${mediaGQLFields(fields.favicon)}
      }
    `
        : ``}
    ${fields.image
        ? `
      image {
        ${mediaGQLFields(fields.image)}
      }
    `
        : ``}
    ${fields.images
        ? `
      images {
        ${mediaGQLFields(fields.images)}
      }
    `
        : ``}
    ${fields.network
        ? `
      network {
        ${networkGQLFields(fields.network)}
      }
    `
        : ``}
    ${fields.updatedBy
        ? `
      updatedBy {
        ${memberGQLFields(fields.updatedBy)}
      }
    `
        : ``}
  `;
};
//# sourceMappingURL=app.fields.js.map